import { RootState } from "@redux/rootReducer";
import { useSelector } from "react-redux";

/** 從 Redux 取得 BD 人員清單 */
export default function useStaffList() {
  const staffList = useSelector((state: RootState) => state.staffs.bdStaffData);

  return staffList;
}
